

<template>
	<div class="hotspot-mobile" v-bind:data-index="index">
		<a @click="onClick" class="link d-block py-2 mb-2 px-4">
			<slot></slot>
		</a>
	</div>
</template>

<script>

import { EventBus } from '@/common/eventbus.js';
import { mapState } from 'vuex';

export default {
	props: ['hotspot', 'index'],
	data: () => {
		return {
		}
	},
	computed: {
		...mapState('navigation', ['current']),
	},
	methods: {
		onClick( event ) {
			EventBus.$emit('hotspot-clicked', this.createEventParameters( event ) );
		},
		createEventParameters( event ) {
			console.log(this.hotspot);
			return Object.assign({
				hotspot: this.hotspot,
				link: this.hotspot.article,
				$el: this.$el,
				originalEvent: event,
			});
		}
	}

}
</script>

<style scoped lang="scss">
		
	.hotspot-mobile {
		.link {
			color: #f6ffff;
			font: 1.1rem/1.2 $font-condensed;
			font-weight: 400;
			color: #000;
			background: rgba(#fff, 0.6);
			letter-spacing: 0.02em;
			transition: 0.2s all;
			user-select: none;
			display: inline-block;
		}
		&.current .link {
			background-color: lighten(#5abfbe, 20%);
		}
	}

	.pflege .hotspot-mobile {
		.link {
			background-color: #80cae3;
		}
		&.current .link {
			background-color: lighten(#80cae3, 10%);
		}
	}

</style>
